// Generador de chips RFID falsos. Permite testear todo el flujo sin lector real.
// Usado en Emergent y como fallback cuando no hay BLE disponible.

export class SimulatorAdapter {
  constructor(label = 'Simulador') {
    this.name = label;
    this.status = 'disconnected';
    this.listeners = new Set();
    this._chipPool = [];
  }

  async isAvailable() {
    return true;
  }

  async requestDevice() {
    this.status = 'connecting';
    await new Promise((r) => setTimeout(r, 200));
    this.status = 'connected';
    return { id: 'simulator-1', name: 'Lector Simulador' };
  }

  async connect() {
    this.status = 'connected';
  }

  async disconnect() {
    this.status = 'disconnected';
  }

  /** Llama a cb(chip) cuando se 'lea' un chip. Retorna unsubscribe. */
  onChipRead(cb) {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  }

  getStatus() {
    return this.status;
  }

  /** Carga una lista de chips conocidos para simular leer animales existentes. */
  loadChipPool(chips) {
    this._chipPool = [...chips];
  }

  /** Emite un chip al azar (de la pool o random). Util para botones "Simular escaneo". */
  emitRandomChip() {
    let chip;
    if (this._chipPool.length > 0) {
      chip = this._chipPool[Math.floor(Math.random() * this._chipPool.length)];
    } else {
      chip = '900164' + Math.floor(Math.random() * 1e9).toString().padStart(9, '0');
    }
    this.emitChip(chip);
    return chip;
  }

  emitChip(chip) {
    this.status = 'reading';
    this.listeners.forEach((cb) => {
      try {
        cb(chip);
      } catch (e) {
        console.error('listener error', e);
      }
    });
    this.status = 'connected';
  }
}
